export const ALL_PERMISSIONS = 'ALL_PERMISSIONS';

// Labels for features
export const featureLabels = {
    reagents_register: 'Códigos de Reactivos',
    reagents_usage: 'Registrar Uso',
    reagents_entries: 'Registrar Ingreso',
    reagents_reports: 'Reportes',
    purchase_orders: 'Órdenes de Compra',
    users_management: 'Personal',
    areas_management: 'Áreas',
    roles_management: 'Roles de usuario',
    reagents_management: 'Reactivos (ajustes)',
};

// Labels for permissions
export const permissionLabels = {
    REAGENT_VIEW: 'Ver',
    REAGENT_CREATE: 'Crear',
    REAGENT_UPDATE: 'Actualizar',
    REAGENT_DELETE: 'Eliminar',
    REAGENTS_USAGE_VIEW: 'Ver',
    REAGENTS_USAGE_CREATE: 'Crear',
    REAGENTS_USAGE_OWN_UPDATE: 'Actualizar propios',
    REAGENTS_USAGE_OWN_DELETE: 'Eliminar propios',
    REAGENTS_USAGE_ALL_UPDATE: 'Actualizar todos',
    REAGENTS_USAGE_ALL_DELETE: 'Eliminar todos',
    REAGENTS_ENTRY_VIEW: 'Ver',
    REAGENTS_ENTRY_CREATE: 'Crear',
    REAGENTS_ENTRY_UPDATE: 'Actualizar',
    REAGENTS_ENTRY_DELETE: 'Eliminar',
    REAGENTS_REPORTS_VIEW: 'Ver reportes',
    REAGENTS_REPORTS_UPDATE: 'Actualizar reportes',
    PO_VIEW: 'Ver',
    PO_CREATE: 'Crear',
    PO_UPDATE: 'Actualizar',
    PO_DELETE: 'Eliminar',
    USERS_VIEW: 'Ver',
    USERS_CREATE: 'Crear',
    USERS_UPDATE: 'Actualizar',
    USERS_DELETE: 'Eliminar',
    AREAS_VIEW: 'Ver',
    AREAS_CREATE: 'Crear',
    AREAS_UPDATE: 'Actualizar',
    AREAS_DELETE: 'Eliminar',
    ROLES_VIEW: 'Ver',
    ROLES_CREATE: 'Crear',
    ROLES_UPDATE: 'Actualizar',
    ROLES_DELETE: 'Eliminar',
    REAGENT_MANAGEMENT_VIEW: 'Ver',
    REAGENT_MANAGEMENT_CREATE: 'Crear',
    REAGENT_MANAGEMENT_UPDATE: 'Actualizar',
    REAGENT_MANAGEMENT_DELETE: 'Eliminar',
};

// Utility functions to get the label for a permission or feature
export const getPermissionLabel = (permissionId) =>
    permissionLabels[permissionId] || permissionId;

export const getFeatureLabel = (featureId) =>
    featureLabels[featureId] || featureId;
